<template>
    <div style="min-height: 500px; height: 100%">
        <p>{{chapter_info.lecture_title}}</p>
        <h3>{{chapter_info.lecture_intro}}</h3>

        <iframe width="100%" height="80%"
                :src="chapter_info.media_src"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>

    </div>
</template>


<script>
    export default {
        name: "Study",
        props: ['chapter_info'],
        created() {

        },
        methods: {},
        data() {
            return {}
        }
    }
</script>

<style scoped>

</style>